<template>
    <div>
        <report-header
            :title="title"
            :isShowDateRange="true"
            :formatDateRangeTitle="dateRange"
        />

        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <QTable
                    :data="tableData"
                    :columns="formattedColumns"
                    :hide-bottom="true"
                    :rows-per-page-options="[0]"
                    :loading="isLoading"
                >
                    <template v-slot:bottom-row>
                        <q-tr
                            v-if="
                                tableData.length == 0 && !isLoading && !isError
                            "
                        >
                            <q-td colspan="8">No records available</q-td>
                        </q-tr>
                    </template>

                    <template v-slot:header-cell="props">
                        <q-th :props="props">
                            <strong class="text-capitalize">{{
                                props.col.label
                            }}</strong>
                        </q-th>
                    </template>
                    <template v-slot:body-cell-Client="props">
                        <q-td :props="props" class="">
                            <client-name
                                :use-router="USE_CLIENT_MODULE_VUE"
                                :client="generateClientObject(props.row)"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-Patient="props">
                        <q-td :props="props">
                            <patient-name
                                :use-router="USE_PATIENT_MODULE_VUE"
                                :patient="generatePatientObject(props.row)"
                                :show-status="true"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-Item="props">
                        <q-td :props="props">
                            <item-name
                                :item="{
                                    name: props.row.Item,
                                    encodedId: props.row.item_encoded_id
                                }"
                            />
                        </q-td>
                    </template>
                    <template v-slot:body-cell-Reference="props">
                        <q-td :props="props">
                            <a
                                v-if="props.row.Reference == 'invoice'"
                                :href="
                                    props.row.reference_id
                                        ? env.APPS +
                                          'billing/invoice/view/' +
                                          props.row.reference_encoded_id
                                        : ''
                                "
                            >
                                {{ props.row.Reference }} #{{
                                    props.row.reference_index
                                }}
                            </a>
                            <estimate-link
                                v-else-if="props.row.Reference == 'estimate'"
                                :estimate="{
                                    id: props.row.reference_encoded_id,
                                    encoded_id: props.row.reference_encoded_id,
                                    ci_url: props.row.reference_id
                                        ? env.APPS +
                                          'billing/estimate/view/' +
                                          props.row.reference_encoded_id
                                        : ''
                                }"
                                :text="`${props.row.Reference} #${props.row.reference_index}`"
                                :useRouter="USE_ESTIMATE_MODULE_VUE"
                            />
                            <span v-else>{{ props.row.Reference }}</span>
                        </q-td>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import { QTable } from "quasar";
import Report from "@/mixins/report";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import PatientName from "@/components/commons/patient-name";
import ClientName from "@/components/commons/client-name";
import ItemName from "@/components/commons/item-name";
import EstimateLink from "@/components/commons/estimate-link";
import "@/css/quasar-table.css";
export default {
    mixins: [Report],
    components: {
        QTable,
        PatientName,
        ClientName,
        ItemName,
        EstimateLink,
        ReportHeader: () => import("@/components/report/report-header")
    },
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("day"),
                    end: this.getEndDate("day"),
                    from: this.converToUnix(this.start),
                    to: this.converToUnix(this.end)
                };
            }
        }
    },
    data() {
        return {
            headerTotal: "Total",
            isLoading: true,
            isError: false,
            tableData: [],
            dateRange: "",
            title: "Declined Items",
            USE_CLIENT_MODULE_VUE: process.env.USE_CLIENT_MODULE_VUE === "true",
            USE_PATIENT_MODULE_VUE:
                process.env.USE_PATIENT_MODULE_VUE === "true"
        };
    },
    computed: {
        formattedColumns() {
            return [
                {
                    name: "Declined",
                    label: "Declined",
                    field: "Declined",
                    align: "center",
                    style: "width:9%"
                },
                {
                    name: "Client",
                    label: "Client",
                    field: "Client",
                    align: "left",
                    style: "width:12%",
                    classes: "text-capitalize"
                },
                {
                    name: "Patient",
                    label: "Patient",
                    field: "Patient",
                    align: "left",
                    style: "width:12%",
                    classes: "text-capitalize"
                },
                {
                    name: "Reference",
                    label: "Reference",
                    field: "Reference",
                    align: "center",
                    style: "width:10%",
                    classes: "text-capitalize"
                },
                {
                    name: "Item",
                    label: "Item",
                    field: "Item",
                    align: "left",
                    style: "width:16%",
                    classes: "text-capitalize"
                },
                {
                    name: "Quantity",
                    label: "Quantity",
                    field: "Quantity",
                    align: "center",
                    format: (val, row) => {
                        if (val.includes("---")) {
                            let quantityString = [];
                            val.split("---").forEach(q => {
                                quantityString.push(
                                    this.convertDecimalWithNegative(q, 3)
                                );
                            });
                            return quantityString.join(" - ") + " " + row.Uom;
                        }
                        return (
                            this.convertDecimalWithNegative(val, 3) +
                            " " +
                            row.Uom
                        );
                    },
                    style: "width:12%"
                },
                {
                    name: "Total",
                    label: this.headerTotal,
                    field: "Total",
                    align: "center",
                    format: (val, row) => {
                        if (val.includes("---")) {
                            let quantityString = [];
                            val.split("---").forEach(q => {
                                quantityString.push(
                                    this.convertDecimalWithNegative(q, 2)
                                );
                            });
                            return quantityString.join(" - ");
                        }
                        return this.convertDecimalWithNegative(val, 2);
                    },
                    style: "width:9%"
                },
                {
                    name: "Reason",
                    label: "Reason",
                    field: "Reason",
                    align: "left",
                    style: "width:8%"
                },
                {
                    name: "Notes",
                    label: "Notes",
                    field: "Notes",
                    align: "left",
                    style: "width:12%"
                }
            ];
        }
    },
    async mounted() {
        let self = this;
        // --- toggle navigation options
        self.data.filterDateOption = true;
        self.data.isShowProvider = false;
        self.data.isShowDateRange = true;

        self._getSetting().then(() => {
            self.data.start = self.getStartDate("day");
            self.data.end = self.getEndDate("day");
            self.data.from = self.converToUnix(self.data.start);
            self.data.to = self.converToUnix(self.data.end);
            self.fetchData();
        });

        self.$root.$on("report-filter-date-range:refresh", function (params) {
            if (params) {
                self.data.from = params.from;
                self.data.to = params.to;
                self.data.start = params.start;
                self.data.end = params.end;
            }
            self.fetchData();
        });
        window.scrollTo(0, 0);
    },
    beforeDestroy: function () {
        this.$root.$off("report-filter-date-range:refresh", this.fetchData);
    },
    methods: {
        generatePatientObject(row) {
            return {
                name: row.Patient,
                encodedId: row.patient_encoded_id,
                isactive: !row.Patient.includes("(deleted)")
            };
        },
        generateClientObject(row) {
            return {
                id: row.client_id,
                name: row.Client.replace("(deleted)", ""),
                encoded_id: !row.Client.includes("(deleted)")
                    ? row.client_encoded_id
                    : null,
                isactive: !row.Client.includes("(deleted)")
            };
        },
        async fetchData() {
            let self = this;
            self.isLoading = true;
            self.isError = false;
            self.dateRange = self.getDateRange(self.data.from, self.data.to);
            await ReportService.getReport(CREPORT.TYPE.DECLINED_ITEMS, {
                from: self.data.from,
                to: self.data.to
            })
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.tableData = res.resource.results.results;
                        self.dateRange = self.getDateRange(
                            res.resource.results.from,
                            res.resource.results.to
                        );
                        if (res.resource.results.currency_symbol) {
                            self.headerTotal =
                                "Total (" +
                                res.resource.results.currency_symbol +
                                ")";
                        }
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e.message);
                    self.isError = true;
                    self._message("Error: Unable to get the report", "danger");
                })
                .finally(() => {
                    self.isLoading = false;
                });
        },
        convertDecimalWithNegative(value, decimalPlace) {
            let numberString = Number(value).toLocaleString(undefined, {
                minimumFractionDigits: decimalPlace,
                maximumFractionDigits: decimalPlace
            });
            if (Number(value) < 0) {
                return "(" + numberString + ")";
            }
            return numberString;
        }
    }
};
</script>
